import { Injectable } from '@angular/core';
import domtoimage from 'dom-to-image';
import * as qz from 'qz-tray';
import { DataService } from '../services/data.service';


@Injectable({
  providedIn: 'root'
})
export class PrintService {
  bill_details:any;
  business_info;
  order_id;

  constructor(public db: DataService) { 

     if(localStorage['print_type'] == 'QZ Tray'){
     this.db.print_emit.subscribe(x => {
      if (x == 'print emit') {
        this.get_business_info();
        this.get_info();
        // this.get_cart_items()
      }
    });
   }

  }

  // Check image url
  // base_Url = "https://meatton.tridotstech.com";
  // product_img(data) {
  //   if (data) {
  //     if (data.indexOf("https") == -1) {
  //       return this.base_Url + data;
  //     } else if (data.indexOf("https") == 0) {
  //       return data;
  //     }
  //   }
  // }

  // End

  print(componentName) {
    // console.log(componentName.innerHTML)
    // var WinPrint =
    // window.open('','','left=0,top=0');
    // WinPrint.document.write(componentName.innerHTML);
    // WinPrint.document.close();
    // WinPrint.focus();
    // WinPrint.print();
    // WinPrint.close();
    // window.setCopies(2);
    window.print();
    // setTimeout(function () {
    //   window.print();
    //   window.close();
    // }, 500);
    // var node = document.getElementById(componentName);

    // domtoimage.toPng(node)
    // .then(function (dataUrl) {
    //     var popup=window.open();
    //       popup.document.write('<img src=' + dataUrl + ' width="100%">');
    //       popup.document.close();
    //       popup.focus();
    //       setTimeout(function() {
    //           popup.print();
    //           popup.close();
    //       }, 500);
    // })
    // .catch(function (error) {
    // });
  }

  fillspace(number, data, type) {
    var qtytotal = number;
    var qtylength = String(data).length
    var qtysum = qtytotal - qtylength;
    if (data) {
      if (qtysum > 0) {
        var qtyspace = data
        for (var j = 0; j < qtysum; j++) {
          if (type == 'backspace') {
            qtyspace = qtyspace + ' ';
          }
          if (type == 'frontspace') {
            qtyspace = ' ' + qtyspace;
          }
        }
      } else {
        var qtyspace = data
      }
      return qtyspace;
    }
  }

  centeralign(number, data) {
    var qtytotal = number;
    var qtylength = String(data).length
    var qtysum = qtytotal - qtylength;
    if (data) {
      if (qtysum > 0) {
        var qtyspace = data
        for (var j = 0; j < qtysum / 2; j++) {
          qtyspace = ' ' + qtyspace + ' ';
        }
      } else {
        var qtyspace = data
      }
      return qtyspace;
    }
  }

   get_business_info(){
    this.db.get_restaturantdetail(localStorage['business']).subscribe((res:any) => {
     // console.log(res)
      if(res.message != undefined)
        this.business_info = res.message[0]
        // console.log("Business info",this.business_info);
    })
  }

  get_info() {
    
    let data = {
      order_id:this.order_id
    }
    this.db.get_order_details(data,1).subscribe((res:any)=>{
      this.bill_details = res.message
      // console.log( this.bill_details);
      
      // if(res.message.order)
      //   this.bill_details = res.message.order;
      // if(res.message.shop_user)
      //   this.bill_details.full_name = res.message.shop_user
      if(this.bill_details.order_item)
        this.bill_details.items = this.bill_details.order_item
       setTimeout(() => {
        // this.modalCtrl.dismiss();
        this.qz_print()
      }, 1000)

    })
    
  }

  // New print code by Bala


  qz_print() {



// qz.security.setCertificatePromise((resolve, reject) => {
//   fetch("assets/digital-certificate.txt", {cache: 'no-store', headers: {'Content-Type': 'text/plain'}})
//    .then(data => resolve(data.text()));
//  });


    //console.log(qz.websocket.isActive())
    if (qz.websocket.isActive()) {

      this.print_data();
    }
    else{
      this.connect().then(() => {
        return this.print_data();
        //return this.print_qr();
      // return this.print_html();
     }).then(() => {
       this.success();              
     }).catch(this.fail);
    }
          
  }
  connect() {
    return new Promise<void>(function (resolve, reject) {
      if (qz.websocket.isActive()) {  // if already active, resolve immediately
        resolve();
      } else {
        // try to connect once before firing the mimetype launcher
        qz.websocket.connect().then(resolve, function retry() {
          // if a connect was not successful, launch the mimetime, try 3 more times
          window.location.assign("qz:launch");
          qz.websocket.connect({ retries: 2, delay: 1 }).then(resolve, reject);
        });
      }
    });
  }
  print_data() {
    var  right = 2.25, left = 2.25;
   // console.log('bill details', this.bill_details)
    var qrsize = {width: 4.28, height: 3.26};
    //var qrconfig = qz.configs.create("POS-80",{units: 'cm', size: qrsize});
    var config = qz.configs.create("POS-80", {encoding: 'ISO-8859-1',units: 'cm', size: qrsize ,margins: {right: right, left: left }});
    config.config.copies = localStorage['no_of_copy'] ? localStorage['no_of_copy'] : 1   //two copies
  
    var bill_description;
    var items:any = [];
    var item_data;
    var qty_mrp = [];
    var total_qty = 0;
     this.bill_details.items.map(res => {
      total_qty = total_qty + res.quantity  //quantity
    })
    var Token_no,Emp_name
    Token_no=this.bill_details.token?this.bill_details.token:'-'
    Emp_name=this.bill_details.shop_user?this.bill_details.shop_user:'-'
  
    var payment_method_ = '';
    this.bill_details.payment_entries.map((res:any,index) => {
      // console.log(this.bill_details.payment_entries.length - 1 > index ?'/':'')
      if(res){
        payment_method_ += res.mode_of_payment; 
        payment_method_ += this.bill_details.payment_entries.length - 1 > index ?' / ':'';
    }
        // payment_method_array.push(res.mode_of_payment)
    })
     console.log(this.bill_details.payment)
    
  var payment_mode = '';
  this.bill_details.payment_entries.map(res =>{
    if(res.mode_of_payment)
       payment_mode += res.mode_of_payment
  })


    this.bill_details.items.map(res => {

     // console.log('bill_details.item', res)
      bill_description=res.attribute_description?res.attribute_description:''
      
      //  var null_string=null;
      //  var _string= undefined || '' || null_string;
      //  res.attribute_description=_string?res.attribute_description.push('-'): res.attribute_description;
      // console.log("attribute_desac", res.attribute_description)
      var description=''
      if( bill_description&& bill_description.length!=0){
       var myHTML =bill_description;
       var br = myHTML.replace(/<br>/g, '\n');
      description = br.replace(/<[^>]+>/g, '');
      // var description=br;
      //console.log(description);
      }

      
  
       var ordered_item_name=res.item_name;
       var item_name=ordered_item_name //.replace(/[^a-zA-Z ]/g,"");
       
      // console.log("html content", description);
     // console.log("des", description);


      var weight;
      if (res.weight < 1000) {
        weight = res.weight + 'g'
      }
      else if (res.weight >= 1000) {
        weight = res.weight / 1000 + 'kg'
      }

    //  console.log(weight,"weight");
     
      
   if (res.tray_no) {
       //items.push(this.title_space(item_name)+'\x0A'+description+'\x09' +'\x09' + res.quantity+'\x09' + res.price.toFixed(2)+'\x09'+ res.price.toFixed(2)+'\x09' + res.amount.toFixed(2) + '\x1B' + '\x61' + '\x30' +'\x0A')
        items.push(this.title_space(item_name)+'\x0A'+description+'\x09' +'\x09'+ weight +'\x09' + res.quantity+'\x09' + res.price.toFixed(2)+'\x09' + res.amount.toFixed(2) + '\x1B' + '\x61' + '\x30' +'\x0A')

        // qty_mrp.push(res.quantity + res.price + res.price + res.amount)
        var item=items.join()
        item_data=item.replace(/,/g,"")
       
      }
      else if (!res.tray_no) {
        // console.log(res);
        // console.log("round", res.price.toFixed(2));
        //  items.push( '\x1B' + '\x74' + '\x68',this.title_space(item_name) +'\x0A'+description+'\x09' +'\x09' +res.quantity+'\x09' +  res.price.toFixed(2)+'\x09' +  res.price.toFixed(2)+'\x09' + res.amount.toFixed(2) + '\x1B' + '\x61' + '\x30'+'\x0A')
         items.push( '\x1B' + '\x74' + '\x68',this.title_space(item_name) +'\x0A'+description+'\x09' +'\x09'+ weight +'\x09' + res.quantity+'\x09' + res.price.toFixed(2)+'\x09' + res.amount.toFixed(2) + '\x1B' + '\x61' + '\x30'+'\x0A')
         //items.push(res.item_name)
         var item=items.join()
         item_data=item.replace(/,/g,"")
         console.log(item_name)
      }
    })
    var qrcode_img= this.db.product_img(this.bill_details.qrcode);
    var logo_img='/assets/logo2.png';
   // console.log(qrcode_img,this.bill_details);  printer-color-1
    var qrdata; 
    var logo;
    var data = [
        logo ='\x1B\x61\x31',{type: 'raw',format: 'image', flavor: 'file', data:logo_img,options: {language: "escp", dotDensity: 'double'}},
      // '\x1B' + '\x45' + '\x01',  //if need title, add title in empty string and add new line /
      '' + '\x1B' + '\x61' + '\x31' + '\x1b' + '\x21' + '\x01' +'\x1b' + '\x45' + '\x00', 
      this.title_length(this.business_info.business_address)+','+this.business_info.city +'-'+this.business_info.zip_code+ '\x1B' + '\x61' + '\x31' +'\x1b'+'\x21'+'\x01'+'\n',
      // this.business_info.city +' '+this.business_info.zip_code+ '\x1B' + '\x61' + '\x31'+ '\n',
      'Phone:' + this.business_info.contact_number + '\x1B' + '\x61' + '\x31'+ '\x1b' + '\x21'+'\x00'+'\x1b'+'\x4D'+'\n'+'\x0A', 
      'GST NO:' + '33ABTFA6471F1Z9' + '\x1B' + '\x61' + '\x31'+ '\x1b' + '\x21'+'\x00'+'\x1b'+'\x4D'+'\n'+'\x0A', 
      // '\x1B' + '\x45' + '\x0D',//bold on
      //  this.bill_details.payment_entries.length != 0 ? payment_method_+'\x1B' + '\x45' +'\x0A'+'\x0A' : this.bill_details.payment_method_name+
      // '\x1B' + '\x45' +'\x0A'+'\x0A', 
      this.get_dashes('\x2D',48) + '\x0A',
      'Bill No: ' + this.bill_details.name + '\x1B' + '\x61' + '\x48'+this.get_space_value("Bill No: ",this.bill_details.name ,"Date: ",this.bill_details.order_date),
      'Date: ' + this.bill_details.order_date + '\x1B' + '\x61' + '\x50'+'\x0A',  
      'Token No: ' + Token_no + '\x1B'+ '\x61'+ '\x30'+this.get_space_value("Token No: ",Token_no ,"Cashier Name:",Emp_name),
      'Cashier Name:'+Emp_name+'\x0A',
      'Payment Mode: ' + payment_mode + '\x1B'+ '\x61'+ '\x30'+'\x0A',
      // 'Name: ' +  '\x1B'+ '\x61'+ '\x30'+'\x0A', 
      // 'No: '+ '\x1B'+ '\x61'+ '\x30'+'\x0A',
       this.get_dashes('\xC4',48) + '\x0A',
       '\x1B' + '\x45' + '\x0D' ,// bold on
      'Item Name '+'\x09'+ 'Weight '+'\x09'+'Qty '+'\x09'+ 'Rate '+'\x09'+ 'Amount ' + '\x1B' + '\x61' + '\x30'+'\x1B'+'\x45'+'\x0A'+'\n', 
        //bold off
        this.get_dashes ('\xC4',48) + '\x0A',  
      // items + '\x1b' + '\x21'+'\x00', 
       item_data + '\x1b' + '\x21'+'\x00', 
        this.get_dashes('\x2D',48) + '\x0A',
      'Sub Total: '+this.bill_details.order_subtotal.toFixed(2)+'\x1B'+ '\x61'+ '\x32'+'\x0A',
      'Total Qty: ' + total_qty + '\x1B' + '\x61' + '\x48'+this.get_space_value("Total Qty: ",total_qty,"Discounts: ",this.bill_details.discount), //'\x09'+'\x09'+'\x09'
      'Discounts: '+this.bill_details.discount + '\x1B' + '\x61' + '\x50' + '\n', 
      'Delivery charges: '+this.bill_details.shipping_charges.toFixed(2)+'\x1B'+ '\x61'+ '\x32'+'\x0A',
      'Total Items: ' +  this.bill_details.items.length + '\x1B' + '\x61' + '\x30'+this.get_space_value("Total Items: ",this.bill_details.items.length,"GST: ",this.bill_details.total_tax_amount.toFixed(2)),
      // 'Total Amount: ',this.bill_details.total_amount.toFixed(2) + '\x1B' + '\x61' + '\x32' + '\n',  
       'GST: ',this.bill_details.total_tax_amount.toFixed(2) + '\x1B' + '\x61' + '\x32' + '\n',
       'Round Off: ',this.bill_details.round_off_value.toFixed(2) + '\x1B' + '\x61' + '\x32' + '\n', 
       'You Have Saved: ' +  this.bill_details.discount+ '\x1B' + '\x61' + '\x30'+this.get_space_value("You Have Saved: ", this.bill_details.discount,"Total Amount: ",this.bill_details.total_amount.toFixed(2)),
       'Total Amount: ',this.bill_details.total_amount.toFixed(2) + '\x1B' + '\x61' + '\x32' + '\n', 
      this.get_dashes('\xC4',48) + '\x0A',
      '**THANK YOU ! VISIT AGAIN**' + '\x1B' + '\x61' + '\x31'+'\x1b' + '\x2D' + '\x49'+'\n',
      '\x1B' +'\x2D' + '\x49',
      this.get_dashes('\xC4',48) + '\x0A',
        // 'Customer Name: ' + this.bill_details.customer_name + '\x1B'+ '\x61'+ '\x30'+'\x0A', 
        'Customer Name: ' +  this.bill_details.customer_name + '\x1B' + '\x61' + '\x30'+this.get_space_value("Customer Name: ",this.bill_details.customer_name,"Payment Status",''),
        'Payment Status'+ '\x1B' + '\x61' + '\x32' + '\n', 
        'Customer Phone No: ' + this.bill_details.phone + '\x1B' + '\x61' + '\x30'+this.get_space_value("Customer Phone No: ",this.bill_details.phone,"",this.bill_details.payment_status),
        this.bill_details.payment_status+ '\x1B' + '\x61' + '\x32' + '\n', 
        // 'Customer Phone No: '+this.bill_details.phone+ '\x1B'+ '\x61'+ '\x30'+'\x0A',
      this.get_dashes('\x2D',48) + '\x0A',
      // QR code
       qrdata ='\x1B\x61\x31',{ 
      type: 'raw',
      format: 'image',
      flavor: 'file',
      data:qrcode_img,
      options: {language: "escp", dotDensity: 'double'}
      },
      '\x0A\x0A\x0A\x1B\x69', //automatic cut paper (now)

      // 'Customer Phone No.+91 ' + this.bill_details.phone + '\x1B' + '\x61' + '\x31' + '\n'+'\x0A'+'\x0A'+'\x0A'+'\x0A', 
    ];   
// console.log("before data",data)


   
     
    return qz.print(config, data);
  }

  // notify successful print
  success() {
    // this.print_qr()
    // alert("Success");
  }
  get_dashes(code,count){
    let dashes =''
    for(let i=0;i<count;i++){
        dashes += code 
    }
    return dashes
 }
//  get_space(data,datatwo){
//     let data_len= data.toString().length    
//     let data_two_len=datatwo.toString().length
//      let space_len = 24 - data_len-data_two_len
//      let space = ''
//      console.log("space length",space_len)
//      for(let i=0;i<space_len;i++){
//        space += ' ' 
//      }
//      return space
//  }

 get_space_value(data1_title,data1_value,data2_title,data2_value){
  //if(data1_title&&data1_value&&data2_title&&data2_value){
  let data1_len= data1_title.toString().length + data1_value.toString().length
  let data2_len=data2_title.toString().length + data2_value.toString().length
   let space_len = 48 - data1_len-data2_len
   let space = ''
   for(let i=0;i<space_len;i++){
     space += ' ' 
   }
   return space
}

 title_space(title){
    let title_len = title.length
    let title_value = ''
    for(let i=0;i<title_len;i++){
      if(i!=0 && i%20 == 0){
        title_value += '\n' + title.charAt(i)
      }
      else{
        title_value += title.charAt(i)
      }
    }
    return title_value
 }
 title_length(title){
  let title_len = title.length
  let title_value = ''
  for(let i=0;i<title_len;i++){
    if(i!=0 && i%45 == 0){
      title_value += '\n' + title.charAt(i)
    }
    else{
      title_value += title.charAt(i)
    }
  }
  return title_value
}

  // exception catch-all
  fail(e) {
    alert("Error: " + e);
  }






  

}
